(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  const selectFramingService = () => {
    const service = new URLSearchParams(window.location.search).get('service');
    const serviceLabels = { framing: 'Custom Framing', apparel: 'Apparel', awards: 'Awards & Recognition' };
    if (!Object.hasOwn(serviceLabels, service)) return;
    document.querySelectorAll('.contact-form select').forEach((select) => {
      if (select.dataset.serviceInitialized) return;
      const option = Array.from(select.options).find((item) => item.value.trim() === serviceLabels[service]);
      if (!option) return;
      select.value = option.value;
      select.dataset.serviceInitialized = 'true';
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', selectFramingService, { once: true });
  } else {
    selectFramingService();
  }
  document.addEventListener('shopify:section:load', selectFramingService);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gr-catalogs"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gr-catalogs')) {
    customElements.define('gr-catalogs', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const grid = this.querySelector('[data-catalog-grid]');
        if (grid) [...grid.children].sort((a, b) => Number(a.dataset.sort) - Number(b.dataset.sort)).forEach(card => grid.appendChild(card));
        const dialog = this.querySelector('dialog');
        const frame = this.querySelector('[data-catalog-frame]');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        this.addEventListener('click', event => {
          const opener = event.target.closest('[data-catalog-open]');
          if (!opener || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          let embed;
          try { embed = new URL(opener.dataset.embed); } catch { return; }
          if (embed.protocol !== 'https:') return;
          event.preventDefault();
          this.opener = opener;
          this.querySelector('[data-catalog-title]').textContent = opener.dataset.title;
          this.querySelector('[data-catalog-fallback]').href = opener.href;
          frame.title = opener.dataset.title;
          frame.src = embed.href;
          dialog.showModal();
        });
        this.querySelector('[data-catalog-close]').addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        });
        dialog.addEventListener('close', () => { frame.removeAttribute('src'); if (this.opener && this.opener.isConnected) this.opener.focus(); });
      }
      disconnectedCallback() { const dialog = this.querySelector('dialog'); if (dialog && dialog.open) dialog.close(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
